module.exports = __webpack_public_path__ + "static/media/creditcard.5710702b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/badges/creditcard.svg
 ** module id = 130
 ** module chunks = 0
 **/